import chroma from 'chroma-js';

import { useAppSelector } from '@/store/hooks';
import { selectUserChannelColor } from '@/store/slices/user/selectors';
import { useMemo } from 'react';
import isColorLightOrDark from './is-color-light-or-dark';
import getRelativeContrastColor from './generate-relative-contrasting-color';
import { EPaletteModes } from '@/types/theme-packs.types';

const useGetChannelColor = () => {
  const channelColor = useAppSelector(selectUserChannelColor);

  return useMemo(() => {
    let color = channelColor || '#333333';
    if (!chroma.valid(color)) {
      console.warn(`Invalid channel color: ${color}. Falling back to default color.`);
      color = '#333333';
    }
    const isLight = isColorLightOrDark(color) === EPaletteModes.Light;
    const achromaticContrastColor = isLight ? '#000000' : '#ffffff';
    const selfContrastColor = getRelativeContrastColor(color, color);
    return {
      '--channel-color': color,
      '--channel-color-achromatic-contrast': achromaticContrastColor,
      '--channel-color-self-contrast': selfContrastColor,
      '--channel-color-mix-achromatic-10': `color-mix(in srgb, ${color}, ${achromaticContrastColor} 10%)`,
      '--channel-color-mix-achromatic-20': `color-mix(in srgb, ${color}, ${achromaticContrastColor} 20%)`,
      '--channel-color-mix-achromatic-30': `color-mix(in srgb, ${color}, ${achromaticContrastColor} 30%)`,
      '--channel-color-mix-self-10': `color-mix(in srgb, ${color}, ${selfContrastColor} 10%)`,
      '--channel-color-mix-self-20': `color-mix(in srgb, ${color}, ${selfContrastColor} 20%)`,
      '--channel-color-mix-self-30': `color-mix(in srgb, ${color}, ${selfContrastColor} 30%)`,
    };
  }, [channelColor]);
};

export default useGetChannelColor;
